import { createMuiTheme } from "@material-ui/core";
import gray from "@material-ui/core/colors/grey";

export const theme = createMuiTheme({
    palette: {
        type: 'light',
        primary: {
            main: gray[900],
            light: gray[700],
            dark: gray[700],
        },
        secondary: {
            main: '#ec008c',
            light: '#ffffffff',
            dark: '#dc005c'
        },
    },
    overrides: {
        MuiPaper: {
            root: {
                backgroundColor: '#fafafa'
            }
        },
        MuiDialog: {
            paper: {
                marginLeft: '20px',
                marginRight: '20px'
            }
        },
        MuiDialogContent: {
            root: {
                padding: '0 12px 12px'
            }
        },
        MuiListItem: {
            gutters: {
                paddingLeft: 0,
                paddingRight: 0,
            }
        },
        MuiDialogActions: {
            action: {
                border: 'none !important',
            }
        },
        MuiMobileStepper: {
            root: {
                backgroundColor: '#fafafa'
            },
            dotActive: {
                backgroundColor: '#74bd43'
            },
            dot: {
                width: '12px',
                height: '12px',
                marginRight: '5px',
                marginLeft: '5px',
            }
        },
        MuiStepIcon: {
            completed: {
                color: '#74bd43 !important'
            },
            root: {
                color: '#212121'
            }
        },
        MuiStepLabel: {
            active: {
                fontWeight: 'bold !important'
            }
        },
        MuiGrid: {
            container: {
                // backgroundColor: '#fafafa'
            },
            item: {
                backgroundColor: '#fafafa'
            }
        },
        MuiButton: {
            root: {},
            flat: {
                alignItems: 'flex-end'
            },
            contained: {
                boxShadow: 'none',
            },
            outlined: {
                border: 'none !important',
            },
            outlinedPrimary: {
                background: 'rgba(0, 0, 0, 0.04)'
            }
        },
        MuiLink: {
            underlineHover: {
                cursor: 'pointer',
            }
        },
        MuiChip: {
            root: {
                border: 'none',
                backgroundColor: '#f4f4f4',
            },
            deleteIcon: {
                color: '#ccc'
            },
            colorSecondary: {
                border: 'none !important',
            },
            label: {
                whiteSpace: 'pre-wrap'
            }
        },
        MuiTableCell: {
            root: {
                borderBottom: 'none'
            },
        },
    },
});

theme.dialogDimentions = {
    width: '90%',
    height: '80vh',
    [theme.breakpoints.up('sm')]: {
        width: '100%',
        height: '70vh',
        maxWidth: '700px !important'
    },
};

theme.listContainer = {
    backgroundColor: '#f9f9f9',
};
